import Switcher from "@components/switcher/Switcher";
import React from "react";
import PrimeCanadaOrderFlowDetails from "./PrimeCanadaOrderFlowDetails";
import PrimeCanadaUserDetails from "./PrimeCanadaUserDetails";
import PrimeLogs from "./PrimeLogs";

interface PrimeDetailsCanadaTabsProps {
  instanceId: string;
  width?: string;
}

const PrimeDetailsCanadaTabs: React.FC<PrimeDetailsCanadaTabsProps> = ({
  instanceId,
}) => {
  const tabs = [
    {
      label: "TRADE",
      component: <PrimeCanadaOrderFlowDetails instanceId={instanceId} />,
    },
    {
      label: "USER",
      component: <PrimeCanadaUserDetails instanceId={instanceId} />,
    },
    {
      label: "LOGS",
      component: (
        <PrimeLogs
          instanceId={instanceId}
          endPoint="/analyticsDashboard/getCADCallbackLogs"
        />
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-[12px]">
      <Switcher tabs={tabs} />
    </div>
  );
};

export default PrimeDetailsCanadaTabs;
